import { useEffect, useState } from "react";

const SCROLL_OFFSET = 100;
const THRESHOLD_STEPS = 200;
const THRESHOLDS = Array.from(
  { length: THRESHOLD_STEPS + 1 },
  (_, i) => i / THRESHOLD_STEPS
);

export const useIsScrolledPastTarget = (
  targetRef: React.RefObject<HTMLElement | null>
) => {
  const [isScrolledPastTarget, setIsScrolledPastTarget] = useState(false);

  useEffect(() => {
    const node = targetRef.current;
    if (!node) return;

    const evaluate = (bottom: number) => {
      const next = bottom <= window.innerHeight - SCROLL_OFFSET;
      setIsScrolledPastTarget((prev) => (prev === next ? prev : next));
    };

    const observer = new IntersectionObserver(
      ([entry]) => evaluate(entry.boundingClientRect.bottom),
      { threshold: THRESHOLDS }
    );
    observer.observe(node);

    const handleResize = () => evaluate(node.getBoundingClientRect().bottom);
    window.addEventListener("resize", handleResize);
    evaluate(node.getBoundingClientRect().bottom);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, [targetRef]);

  return isScrolledPastTarget;
};
